<template>
  <b-container fluid class="question-banner">
    <b-row class="my-5" align-h="center">
      <b-col cols="9" lg="8" class="banner" :style="cssVars">
        <p>{{ text }}</p>
				<b-button :href="button.url" :target="button.target">
					{{ button.title }}
				</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { marked } from 'marked'
import DOMPurify from 'dompurify'

export default {
  props: {
		icon: Object,
    text: String,
		button: Object
  },
	computed: {
		cssVars() {
      return {
				"--background-image-url": `url(/strapi/${this.icon.data.attributes.url})`
			}
    }
	},
  methods: {
    sanitizedContent(content) {
      return DOMPurify.sanitize(marked(content))
    }
  }
}
</script>

<style scoped src="@/assets/css/question-banner.css"/>
